/**
 * @generated SignedSource<<6a0a4e21576a9cca12aa4671b5bc0eb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SharedReportResetPasswordInput = {
  sharedId: string;
  clientMutationId?: string | null;
};
export type sharedReportResetPasswordMutation$variables = {
  input: SharedReportResetPasswordInput;
};
export type sharedReportResetPasswordMutation$data = {
  readonly sharedReportResetPassword: {
    readonly success: boolean | null;
    readonly viewer: {
      readonly id: string;
    } | null;
  } | null;
};
export type sharedReportResetPasswordMutation = {
  variables: sharedReportResetPasswordMutation$variables;
  response: sharedReportResetPasswordMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharedReportResetPasswordPayload",
    "kind": "LinkedField",
    "name": "sharedReportResetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedReportResetPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedReportResetPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c710a86111b735a3d130413f3bd0ee31",
    "id": null,
    "metadata": {},
    "name": "sharedReportResetPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation sharedReportResetPasswordMutation(\n  $input: SharedReportResetPasswordInput!\n) {\n  sharedReportResetPassword(input: $input) {\n    success\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "301a1dda7a53e9a0611f58e2eade3d4f";

export default node;
